'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var IconButton = require('@material-ui/core/IconButton');
var styles = require('@material-ui/styles');
var KeyboardArrowLeftIcon = require('@material-ui/icons/KeyboardArrowLeft');
var KeyboardArrowRightIcon = require('@material-ui/icons/KeyboardArrowRight');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var KeyboardArrowLeftIcon__default = /*#__PURE__*/_interopDefaultLegacy(KeyboardArrowLeftIcon);
var KeyboardArrowRightIcon__default = /*#__PURE__*/_interopDefaultLegacy(KeyboardArrowRightIcon);

var DRAWER_CLOSED_WIDTH = 21;
var DRAWER_OPEN_WIDTH = 256;
var useStyles = styles.makeStyles(theme => ({
  menu: {
    position: 'fixed',
    paddingTop: 16,
    top: 48,
    bottom: 0,
    left: 0,
    width: props => !props.hasContent ? 0 : props.isOpen || props.isHovering ? DRAWER_OPEN_WIDTH : DRAWER_CLOSED_WIDTH,
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[800],
    borderRight: "1px solid ".concat(theme.palette.divider),
    overflowX: 'visible',
    overflowY: 'auto',
    zIndex: theme.zIndex.drawer,
    transition: "width 0.15s ease"
  },
  content: {
    pointerEvents: props => props.isOpen || props.isHovering ? 'unset' : 'none',
    opacity: props => props.isOpen || props.isHovering ? 1 : 0,
    transition: 'opacity 0.15s ease'
  },
  button: {
    zIndex: theme.zIndex.drawer + 2,
    opacity: props => !props.hasContent ? 0 : !props.isOpen && props.isHovering ? 0 : !props.isOpen || props.isOpen && props.isHovering ? 1 : 0,
    position: 'fixed',
    boxSizing: 'border-box',
    top: 48 + 18,
    left: props => props.isOpen || props.isHovering ? DRAWER_OPEN_WIDTH - 15 : DRAWER_CLOSED_WIDTH - 15,
    transition: 'left 0.15s ease, opacity 0.15s ease',
    // left: 21 + 56 - 14,
    height: 28,
    width: 28,
    border: "1px solid ".concat(theme.palette.divider),
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[900],
    borderRadius: '50%',
    // '&$isOpen': {
    //   // left: 256 + 56 - 14,
    //   opacity: 0,
    // },
    // '&$isHovering': {
    //   opacity: 1,
    // },
    '&:hover': {
      border: "1px solid ".concat(theme.palette.primary.main),
      opacity: 1
    },
    // When the menu is in `!isOpen && isHovering` disable the menu button.
    // This prevents the user trying to get the button while also trying to
    // hover.
    pointerEvents: props => !props.hasContent || !props.isOpen && props.isHovering ? 'none' : 'unset',
    // Horizontally and vertically align the icon.
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
/**
 * Menu panel.
 */

var MenuPanel = _ref => {
  var {
    isOpen,
    toggle,
    children,
    hasContent = false
  } = _ref;
  var [isHovering, setIsHovering] = React__default['default'].useState(false);
  var classes = useStyles({
    isOpen,
    isHovering,
    hasContent
  });
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.menu,
    onMouseEnter: () => setIsHovering(true),
    onMouseLeave: () => setIsHovering(false)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.content
  }, isOpen || isHovering ? children : null)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.button
  }, /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    className: classes.iconButton,
    onClick: () => toggle()
  }, isOpen ? /*#__PURE__*/React__default['default'].createElement(KeyboardArrowLeftIcon__default['default'], null) : /*#__PURE__*/React__default['default'].createElement(KeyboardArrowRightIcon__default['default'], null))));
};
MenuPanel.propTypes = {
  /** Content of the menu list. */
  children: index.node,
  isOpen: index.bool,
  toggle: index.func,
  hasContent: index.bool
};

exports.MenuPanel = MenuPanel;
